// API Configuration
// Centralized API URL configuration for the application

export const API_CONFIG = {
    // Base URL for API endpoints
    BASE_URL: process.env.REACT_APP_API_URL || 'https://api.bufferio.app/api',
    
    // Base URL for backend server (for files, images, etc.)
    SERVER_URL: process.env.REACT_APP_SERVER_URL || 'https://api.bufferio.app',
    
    // Timeout settings
    TIMEOUT: 30000, // 30 seconds
    
    // File upload settings
    MAX_IMAGE_SIZE: 100 * 1024 * 1024, // 100MB in bytes
    
    // Polling intervals
    MESSAGE_REFRESH_INTERVAL: 10000, // 10 seconds
    HEALTH_CHECK_INTERVAL: 10000, // 10 seconds
  };
  
  // Helper function to get full URL for relative paths
  export const getFullUrl = (path: string): string => {
    if (!path) return '';
    
    // If it's already a full URL, return as is
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path;
    }
    
    // If it's a data URL (base64), return as is
    if (path.startsWith('data:')) {
      return path;
    }
    
    // If it starts with '/', prepend server URL
    if (path.startsWith('/')) {
      return `${API_CONFIG.SERVER_URL}${path}`;
    }
    
    // Otherwise, prepend server URL with slash
    return `${API_CONFIG.SERVER_URL}/${path}`;
  };
  
  export default API_CONFIG;
  
  
  





